import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteGridModal = ({ show, handleClose, project, onConfirmDelete }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Body className="text-center">
        <h5>Are you sure?</h5>
        <p className="text-muted">
          Delete <b>{project?.title}</b> project?
        </p>

        <div className="d-flex justify-content-center gap-2">
          <Button variant="light" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirmDelete}>
            Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteGridModal;
